var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-sidebar"},[_c('div',{staticClass:"slimscrollright"},[_c('div',{staticClass:"rpanel-title"},[_vm._v(" Chat "),_c('span',[_c('i',{staticClass:"ti-close right-side-toggle"})])]),_vm._v(" "),_c('div',{staticClass:"r-panel-body"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8d617f0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RightSidebar.vue
// module id = null
// module chunks = 